/**
 * Shared scoped CSS for the marketplace cards — the hover treatment
 * akademi-sem's shop cards use (`shadow-sm → shadow-md` + a small lift) plus
 * the "cart icon bounces left on card hover" flourish (`animate-bounceLeft`
 * there). Injected once per card via `<style>` since inline style can't do
 * `:hover` / `@keyframes`.
 */
export const MARKET_CARD_CSS = `
.mp-card {
  box-shadow: var(--shadow-sm, 0 1px 3px rgba(0,0,0,0.08));
  transition: box-shadow 180ms ease, transform 180ms ease;
}
.mp-card:hover {
  box-shadow: var(--shadow-md, 0 8px 24px rgba(0,0,0,0.12));
  transform: translateY(-3px);
}
@keyframes mp-bounce-left {
  0%, 100% { transform: translateX(-25%); animation-timing-function: cubic-bezier(0.8,0,1,1); }
  50%      { transform: translateX(0);    animation-timing-function: cubic-bezier(0,0,0.2,1); }
}
/* akademi-sem: the footer cart icon just tints brand + bounces on card hover
   (it's a bare glyph, not a filled button). */
.mp-card:hover .mp-cart-icon-btn { color: var(--color-brand-600, #287f96) !important; }
.mp-card:hover .mp-cart-glyph { animation: mp-bounce-left 1s both infinite; }
`;
